import URC from 'ui-react-common';
import * as types from './action-types';

const api = URC.services.coreAPIInstance;

const fetchDenialReasons = () => (dispatch) => {
    dispatch(fetchingDenialReasons());
    return api
        .fetchDenialReasons()
        .then((something) => dispatch(receivedAdverseAction(something)))
        .catch((error) => {
            dispatch(failedFetchingDenialReasons(error));
        });
};

const fetchingDenialReasons = () => ({
    type: types.FETCHING_DENIAL_REASONS,
});

const failedFetchingDenialReasons = (error) => ({
    type: types.FAILED_FETCHING_DENIAL_REASONS,
    error: error,
});

const receivedAdverseAction = (response) => {
    const { denialReasons, canReapply, reapplicationDate } = response.data;
    return {
        type: types.SUCCESSFULLY_RECEIVED_DENIAL_REASONS,
        denialReasons,
        canReapply,
        reapplicationDate,
    };
};

export default {
    fetchDenialReasons,
    fetchingDenialReasons,
    failedFetchingDenialReasons,
    receivedAdverseAction
};
